var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPoster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2534 20.4927L35.5834 23.4887C36.9754 24.0567 38.4994 23.0347 38.4994 21.5307V8.25265C38.4994 6.74865 36.9754 5.72465 35.5834 6.29265L28.2534 9.28865",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.608 28.7817H21.146C25.514 28.7817 28.254 25.9357 28.254 21.9057V7.87568C28.254 3.84568 25.526 0.99968 21.146 0.99968H8.608C4.226 0.99968 1.5 3.84568 1.5 7.87568V21.9057C1.5 25.9357 4.226 28.7817 8.608 28.7817Z",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPoster);
export default __webpack_public_path__ + "static/media/no_poster.0d167e4e17cdf83e6fd05446cc6403f3.svg";
export { ForwardRef as ReactComponent };